import { useState, useEffect, useRef } from 'react';

export default function useOutsideAlert(initialIsVisible) {
    const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
    const ref = useRef(null);

    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setIsComponentVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        //console.log("I#m here")
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [ref]);

    return { ref, isComponentVisible, setIsComponentVisible };
}